import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var text_vertical_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M7 5.6v1.7l2.6.9v3.9L7 13v1.7L17.5 11V9.3L7 5.6zm4.2 6V8.8l4 1.4-4 1.4zm-5.7 5.6V5.5H4v14.3l3.6-2.2-.8-1.3-1.3.9z" }) });
export {
  text_vertical_default as default
};
//# sourceMappingURL=text-vertical.js.map
